import {
    type FC
} from "react";
import {
    type GestureResponderEvent,
    Platform
} from "react-native";
import type ITimelineLinkProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import type {
    TimelinePartContentProps
} from "../../type";
import {
    withTimelineContext
} from "../../context";
import Text from "../../../text";

const TimelineLinkContent: FC<TimelinePartContentProps<ITimelineLinkProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    onPress,
    style,
    href,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        radiuses,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered
    } = useInteractionState();

    const {
        container: containerDynamicStyle
    } = useStyles({
        isUnderlined: isHovered,
        isFocusVisible,
        radiuses,
        borders,
        colors
    });

    const isWeb = Platform.OS === "web";

    const onMouseLeave = (event: GestureResponderEvent) => {
        interactionHandlers.onHoverOut(event as never);

        interactionHandlers.onPressOut(event);
    };

    const webProps = isWeb ? {
        onMouseEnter: interactionHandlers.onHoverIn,
        dataSet: interactionHandlers.dataSet,
        onFocus: interactionHandlers.onFocus,
        onBlur: interactionHandlers.onBlur,
        onMouseLeave,
        href
    } : {};

    return <Text
        {...props}
        {...webProps}
        style={[
            style,
            stylesheet.container,
            isHovered ? stylesheet.underlined : undefined,
            containerDynamicStyle
        ]}
        customTheme={customTheme}
        variant="labelMediumSize"
        onPress={onPress}
        color="high"
        role="link"
    >
        {children}
    </Text>;
};
export default withTimelineContext("Link", TimelineLinkContent);
